module.exports = __webpack_public_path__ + "img/iconControlGate.e5eebdd2.svg";